export default "__VITE_ASSET__CezUTVLm__"